<template lang="pug">
el-drawer(
  :model-value="modelValue"
  title="Embed your shop"
  size="440px"
  append-to-body
  @update:model-value="$emit('update:modelValue', $event)"
)
  .c-embed
    p.c-embed__intro
      | Add your shop to your website, or share the link and QR code anywhere supporters are.

    h4.c-embed__label Shareable link
    .c-embed__field
      el-input(:model-value="shopUrl" readonly)
      el-button(@click="copy(shopUrl, 'Link')") Copy

    h4.c-embed__label Embed code
    el-input(:model-value="embedCode" type="textarea" :rows="4" readonly)
    el-button.mt-2(@click="copy(embedCode, 'Embed code')") Copy embed code

    h4.c-embed__label QR code
    .c-embed__qr
      qrcode-vue(:value="shopUrl" :size="180" level="M")
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { ElDrawer, ElMessage } from 'element-plus';
import QrcodeVue from 'qrcode.vue';

export default defineComponent({
  name: 'ShopEmbedDrawer',
  components: { ElDrawer, QrcodeVue },
  props: {
    modelValue: { type: Boolean, default: false },
    orgId: { type: String, required: true },
  },
  emits: ['update:modelValue'],
  setup(props) {
    const origin = import.meta.env.VITE_WEB_BASE_URL || `${window.location.origin}/web`;
    const base = origin.replace(/\/web\/?$/, '');
    const shopUrl = computed(() => `${base}/web/profile/organization/${props.orgId}`);
    const embedCode = computed(
      () => `<iframe src="${base}/web/embed/organization/${props.orgId}" `
        + 'width="100%" height="720" style="border:0" title="Spotlight shop"></iframe>',
    );

    async function copy(text: string, label: string) {
      try {
        await navigator.clipboard.writeText(text);
        ElMessage.success(`${label} copied`);
      } catch (e) {
        ElMessage.error('Could not copy. Please select the text and copy it manually.');
      }
    }
    return { shopUrl, embedCode, copy };
  },
});
</script>

<style lang="scss" scoped>
.c-embed {
  &__intro { margin: 0 0 8px; color: #4b5563; font-size: 14px; }
  &__label { margin: 20px 0 8px; font-size: 13px; font-weight: 700; color: #111827; }
  &__field { display: flex; gap: 8px; }
  &__qr {
    display: flex;
    justify-content: center;
    padding: 16px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
  }
}
</style>
